var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 66 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17662 60.0009C5.43719 60.0009 2.97235 58.5916 1.58287 56.2304C0.193389 53.8697 0.158131 51.0304 1.48831 48.6355L26.312 3.93659C27.6806 1.47175 30.1807 0 33.0003 0C35.8198 0 38.3199 1.47175 39.6886 3.93659L64.5123 48.6355C65.8419 51.0304 65.8061 53.8697 64.4172 56.2304C63.0277 58.5911 60.5628 60.0009 57.8234 60.0009H8.17662Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86202 49.3976L27.6857 4.69816C30.002 0.527046 36.0012 0.527046 38.3175 4.69816L63.1412 49.3976C65.3918 53.4507 62.4611 58.4306 57.8253 58.4306H8.17795C3.54207 58.4306 0.611398 53.4507 2.86202 49.3976Z",
    fill: "#F95858"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3359 56.4274C42.1433 49.6418 48.9315 42.8376 55.7165 36.0296L47.5928 21.4014C41.8927 27.1014 36.1922 32.8014 30.4922 38.502C24.2734 44.7212 18.0542 50.94 11.8354 57.1587L10.5635 58.4307H33.3181C33.9896 57.7618 34.6649 57.0967 35.3359 56.4274Z",
    fill: "#CC1313"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5073 37.4551C53.5232 40.4493 50.5423 43.4468 47.555 46.4378C43.5575 50.4407 39.5552 54.4387 35.5476 58.4308H57.8242C62.46 58.4308 65.3907 53.4509 63.1401 49.3979L56.5079 37.4551H56.5073Z",
    fill: "#CC1313"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0206 41.3453L27.426 23.6998V23.367C27.426 22.5213 28.1114 21.8359 28.9571 21.8359H37.0413C37.8869 21.8359 38.5723 22.5213 38.5723 23.367V23.6998L36.9424 41.348C36.873 42.1001 36.2421 42.6755 35.4867 42.6755H30.4764C29.7199 42.6755 29.0885 42.0985 29.0201 41.3447L29.0206 41.3453ZM28.768 49.6651V45.9016C28.768 45.2525 29.2942 44.7263 29.9432 44.7263H36.0177C36.6668 44.7263 37.193 45.2525 37.193 45.9016V49.6651C37.193 50.3141 36.6668 50.8403 36.0177 50.8403H29.9432C29.2942 50.8403 28.768 50.3141 28.768 49.6651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.72ca58e48b27f97b6aaf3563be26a00f.svg";
export { ForwardRef as ReactComponent };